import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Form, Select } from 'semantic-ui-react';

import { Filter, Main } from 'Containers';
import { TitledCard } from 'Components/';
import { DISCONTINUED_INGREDIENTS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { DiscontinuedIngredientsFieldEnum as Fields } from 'Common/FieldEnum';
import { withReportSubscription } from 'State/report/withReportSubscription';
import { getCycleMenus } from 'Pages/recipepreparation/state/actions';
import { getCycleMenuOptions } from 'Pages/recipepreparation/state/selectors';
import { extractTruthyKeys } from 'Common/FormHelper';
import { useApi } from 'Common/Hooks';

import { IngredientsForm } from './components/IngredientsForm';
import { ViewTypeOptions, ViewTypeEnum } from './helpers/constants';

const INITIAL_VALUES = {
  [Fields.IngredientIds]: {},
  [Fields.CycleMenuId]: 0,
  [Fields.PrintRecipe]: true,
};

const PARAMS_INITIAL_VALUES = {
  ViewType: ViewTypeEnum.InRecipes,
  CycleMenuId: 0,
};

function DiscontinuedIngredientsReportContainer({
  getCycleMenus,
  cycleMenuOptions,
  reportFetching,
  getReport,
}) {
  const [params, setParams] = React.useState(PARAMS_INITIAL_VALUES);
  const [{ loading, data: discontinuedIngredients }, { request }] = useApi([]);

  const mainProps = () => ({
    toolbox: {
      formName: DISCONTINUED_INGREDIENTS_REPORT_FORM_NAME,
      saveButtonProps: {
        content: 'View',
        loading: reportFetching,
        disabled: reportFetching,
      },
      shown: true,
    },
  });

  React.useEffect(() => {
    getCycleMenus();
  }, []);

  React.useEffect(() => {
    if (
      params.ViewType === ViewTypeEnum.InCycleMenu &&
      params.CycleMenuId === 0
    ) {
      return;
    }
    request.post('Ingredient/GetDiscontinuedIngredients', params);
  }, [params]);

  const handleSubmit = (values) => {
    const ingredientIds = extractTruthyKeys(values.IngredientIds);
    getReport('Reports/DiscontinuedIngredients', {
      ...values,
      ...params,
      [Fields.IngredientIds]: ingredientIds,
    });
  };

  return (
    <Fragment>
      <Filter title="Discontinued Ingredients" />
      <Main {...mainProps()}>
        <TitledCard title={'Filters'}>
          <Form.Field>
            <label>Discontinued Ingredients</label>
            <Select
              value={params.ViewType}
              options={ViewTypeOptions}
              onChange={(event, data) =>
                setParams({ ...params, ViewType: data.value })
              }
            />
            {params.ViewType === ViewTypeEnum.InCycleMenu && (
              <Fragment>
                <label>Cycle Menu</label>
                <Select
                  value={params.CycleMenuId}
                  options={cycleMenuOptions}
                  onChange={(event, data) =>
                    setParams({ ...params, CycleMenuId: data.value })
                  }
                />
              </Fragment>
            )}
          </Form.Field>
        </TitledCard>
        <TitledCard title={'Discontinued Ingredients'}>
          <IngredientsForm
            onSubmit={handleSubmit}
            ingredients={discontinuedIngredients}
            initialValues={INITIAL_VALUES}
            loading={loading}
          />
        </TitledCard>
      </Main>
    </Fragment>
  );
}

const mapState = (state) => ({
  cycleMenuOptions: getCycleMenuOptions(state),
});

const mapDispatch = {
  getCycleMenus,
};

export const DiscontinuedIngredients = withReportSubscription(
  connect(mapState, mapDispatch)(DiscontinuedIngredientsReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/DiscontinuedIngredients/DiscontinuedIngredients.js